import React from 'react';

export default function GlobalFooter() {
  return (
    <footer className="bg-gray-900 text-gray-300 h-[60px] py-4 px-6 shadow-md transition-all duration-300">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center text-sm">
        {/* Left - Copyright */}
        <div className="mb-2 md:mb-0 text-center md:text-left">
          <p>&copy; {new Date().getFullYear()} Million2Trillion. All rights reserved.</p>
        </div>

        {/* Right - Links */}
        <div className="flex flex-wrap justify-center gap-4">
          <a href="/faq" className="hover:text-white transition">FAQ</a>
          <a href="/terms" className="hover:text-white transition">Terms</a>
          <a href="/privacy" className="hover:text-white transition">Privacy</a>
          <a href="/about" className="hover:text-white transition">About</a>
          <a href="/support" className="hover:text-white transition">Support</a>
        </div>
      </div>
    </footer>
  );
}
